export const tableData = [
  {
    borrower: "АО НК «КазМунайГаз»",
    creditor: "АО «Kazatomprom»",
    sum: 120000000,
    highlight: true,
  },
  {
    borrower: "АО «Kazatomprom»",
    creditor: "АО «Халык Банк Казахстана»",
    sum: "95000000",
    highlight: true,
  },
  {
    borrower: "АО «Халык Банк Казахстана»",
    creditor: "АО НК «КазМунайГаз»",
    sum: "87000000",
    highlight: true,
  },
  { borrower: "JSC Kaspi.kz", creditor: "АО «Samruk‑Kazyna»", sum: "50000000" },
  {
    borrower: "АО «Самрук‑Казына»",
    creditor: "АО «КазТемирЖолы»",
    sum: "60000000",
  },
  { borrower: "АО «КазТемирЖолы»", creditor: "АО «Казпочта»", sum: "15000000" },
  { borrower: "АО «Казпочта»", creditor: "АО «KEGOC»", sum: "22000000" },
  {
    borrower: "АО «KEGOC»",
    creditor: "ТОО «Корпорация «Казахмыс»»",
    sum: "30000000",
  },
  {
    borrower: "ТОО «Корпорация «Казахмыс»»",
    creditor: "АО «КазХром»",
    sum: "18000000",
  },

  { borrower: "АО «КазХром»", creditor: "Kazzinc Ltd", sum: "27000000" },
  { borrower: "Kazzinc Ltd", creditor: "АО «Aitas KZ»", sum: "35000000" },
  { borrower: "АО «Aitas KZ»", creditor: "АО «Имсталькон»", sum: "12000000" },
  { borrower: "АО «Имсталькон»", creditor: "ТОО «Саутс‑Ойл»", sum: "14000000" },
  {
    borrower: "ТОО «Саутс‑Ойл»",
    creditor: "АО «Алюминий Казахстана»",
    sum: "26000000",
  },
  {
    borrower: "АО «Алюминий Казахстана»",
    creditor: "АО «QazaqGaz»",
    sum: "33000000",
  },
  {
    borrower: "АО «QazaqGaz»",
    creditor: "ТОО «СП «Казгермунай»»",
    sum: "21000000",
  },
  {
    borrower: "ТОО «СП «Казгермунай»»",
    creditor: "ТОО «KMG PetroChem»",
    sum: "9000000",
  },
  {
    borrower: "ТОО «KMG PetroChem»",
    creditor: "АО «КазАтомПром Переработка»",
    sum: "11000000",
  },
  {
    borrower: "АО «КазАтомПром Переработка»",
    creditor: "АО «КазТемирЖолы»",
    sum: "12500000",
  },
  { borrower: "АО «КазТемирЖолы»", creditor: "АО «KEGOC»", sum: "29500000" },
  { borrower: "АО «KEGOC»", creditor: "АО «Самрук‑Казына»", sum: "31000000" },
  { borrower: "АО «Самрук‑Казына»", creditor: "АО «Казпочта»", sum: "5000000" },
  {
    borrower: "АО «Казпочта»",
    creditor: "АО «Халык Банк Казахстана»",
    sum: "13000000",
  },
  {
    borrower: "АО «Халык Банк Казахстана»",
    creditor: "АО «QazaqGaz»",
    sum: "27000000",
  },
  { borrower: "АО «QazaqGaz»", creditor: "ТОО «Саутс‑Ойл»", sum: "22000000" },
  { borrower: "ТОО «Саутс‑Ойл»", creditor: "AO «Aitas KZ»", sum: "15000000" },
  { borrower: "AO «Aitas KZ»", creditor: "АО «Kazatomprom»", sum: "19000000" },
  { borrower: "АО «Kazatomprom»", creditor: "АО «Имсталькон»", sum: "24000000" },
  {
    borrower: "АО «Имсталькон»",
    creditor: "АО «Алюминий Казахстана»",
    sum: "8000000",
  },
  {
    borrower: "АО «Алюминий Казахстана»",
    creditor: "АО «КазМунайГаз»",
    sum: "18000000",
  },
  { borrower: "АО «КазМунайГаз»", creditor: "JSC Kaspi.kz", sum: "26000000" },
  { borrower: "JSC Kaspi.kz", creditor: "АО «КазХром»", sum: "7000000" },
  {
    borrower: "АО «КазХром»",
    creditor: "АО «КазАтомПром Переработка»",
    sum: "9000000",
  },
];
